/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */

import { useCallback,  useEffect, useState } from 'react';

const useDirtyInput = (onChange, onBlur, value, defaultValue, resetDirty) => {
    const [state, setState] = useState({
        inputDirty: !!(value || defaultValue),
        initiallyDirty: !!(value || defaultValue)
    });

    useEffect(() => {
        setState(s => ({ ...s, initiallyDirty: !!(value || defaultValue) }));
    }, [value, defaultValue]);

    useEffect(() => {
        setState(s => ({ ...s, inputDirty: s.initiallyDirty }));
    }, [resetDirty]);

    const _onChange = useCallback((event) => {
        setState(s => ({ ...s, inputDirty: true }));

        onChange && onChange(event);
    }, [onChange]);

    const _onBlur = useCallback((event) => {
        setState(s => ({ ...s, inputDirty: true }));

        onBlur && onBlur(event);
    }, [onBlur]);

    return [state.inputDirty, _onChange, _onBlur];
};

export { useDirtyInput };